import axios from 'axios';

export const apiService = axios.create({
  baseURL: 'https://mimos.fenix-pos.com/',
  timeout: 12000000,
});

export const apiService2 = axios.create({
  baseURL: 'https://mimos.pos-fenix.com/',
  timeout: 12000000,
});

export default apiService;